import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";
import { Auth0Plugin } from "./auth";
import VueAnalytics from "vue-analytics";
import VueBreadcrumbs from "vue-2-breadcrumbs";
Vue.config.productionTip = false;
import { library } from "@fortawesome/fontawesome-svg-core";
import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);
import {
  faUserSecret,
  faHeart,
  faSyncAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faUserSecret, faHeart, faSyncAlt);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID || "UA-142867768-1",
  disableScriptLoader: false,
  router
});
const domain = process.env.VUE_APP_AUTH0_DOMAIN;
const clientId = process.env.VUE_APP_AUTH0_CLIENT_ID;
const audience = process.env.VUE_APP_AUTH0_AUDIENCE;
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

Vue.use(ElementUI);
Vue.use(VueBreadcrumbs);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
